export default "__VITE_ASSET__CQd7DG0r__"